import { combineReducers } from 'redux';
import {
  createEntryReducer,
  createListReducer,
  createPendingReducer,
} from 'app/api/redux-jigsaw/userdata/utils/reducer-parts';

export function createDataReducer({
  get,
  add,
  del,
  update = 'NONE',
  listName,
  itemName,
}) {
  return combineReducers({
    list: createListReducer({ get, add, del, listName, itemName }),
    entries: createEntryReducer({ get, add, update, listName, itemName }),
    pending: createPendingReducer({ add, del, update }),
  });
}
